import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const p=i("turkey",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V20.5H0V4.5Z"
                fill="#E30A17" />
            <path
                d="M11.1302 12.5002L14.7486 11.3246L12.5126 14.4023V10.5981L14.7486 13.6759L11.1302 12.5002ZM11.3767 14.6393C10.1956 16.5062 7.72451 17.0617 5.85767 15.8806C3.99084 14.6995 3.43531 12.2284 4.61643 10.3616C5.79755 8.49475 8.26861 7.93922 10.1354 9.12034C10.6358 9.43686 11.0597 9.86121 11.3767 10.3616C10.1956 9.0473 8.17221 8.93897 6.85743 10.1206C5.54314 11.3017 5.43482 13.3251 6.61643 14.6398C7.79755 15.9541 9.82091 16.0625 11.1357 14.8808C11.2202 14.8048 11.3007 14.7243 11.3767 14.6398V14.6393Z"
                fill="white" />
        </svg>
    `),r=i("turkey_rounded",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19486_135988)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M-1.375 0.5H34.625V24.5H-1.375V0.5Z"
                    fill="#E30A17" />
                <path
                    d="M15.3223 12.5003L20.7499 10.7368L17.3958 15.3535V9.64715L20.7499 14.2638L15.3223 12.5003ZM15.692 15.709C13.9203 18.5093 10.2137 19.3426 7.41347 17.5709C4.61322 15.7992 3.77993 12.0926 5.5516 9.29237C7.32328 6.49212 11.0299 5.65883 13.8301 7.43051C14.5807 7.90529 15.2164 8.54181 15.692 9.29237C13.9203 7.32094 10.8853 7.15846 8.91309 8.93088C6.94166 10.7026 6.77918 13.7376 8.5516 15.7098C10.3233 17.6812 13.3583 17.8437 15.3305 16.0713C15.4572 15.9572 15.5779 15.8365 15.692 15.7098V15.709Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19486_135988">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `),C=i("TRY",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19486_135988)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M-1.375 0.5H34.625V24.5H-1.375V0.5Z"
                    fill="#E30A17" />
                <path
                    d="M15.3223 12.5003L20.7499 10.7368L17.3958 15.3535V9.64715L20.7499 14.2638L15.3223 12.5003ZM15.692 15.709C13.9203 18.5093 10.2137 19.3426 7.41347 17.5709C4.61322 15.7992 3.77993 12.0926 5.5516 9.29237C7.32328 6.49212 11.0299 5.65883 13.8301 7.43051C14.5807 7.90529 15.2164 8.54181 15.692 9.29237C13.9203 7.32094 10.8853 7.15846 8.91309 8.93088C6.94166 10.7026 6.77918 13.7376 8.5516 15.7098C10.3233 17.6812 13.3583 17.8437 15.3305 16.0713C15.4572 15.9572 15.5779 15.8365 15.692 15.7098V15.709Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19486_135988">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{C as TRY,p as Turkey,r as TurkeyRounded};
